<div class="avatar__container">
  <span *ngIf="settings?.isShowLabelNameLeft">
    {{ displayName }}
  </span>

  <!-- TODO: Implementar tooltip para os avatares -->
  <div
    class="avatar avatar--circle"
    [title]="displayName"
    [style.width.px]="settings?.size ? settings?.size : DEFAULT_SIZE"
    [style.height.px]="settings?.size ? settings?.size : DEFAULT_SIZE"
    [ngStyle]="{
      'background-color': backgroundColor
    }"
  >
    <img
      *ngIf="settings?.imageUrl"
      [src]="settings?.imageUrl"
      [alt]="displayName || 'Avatar'"
      class="avatar__image"
    />

    <span
      *ngIf="!settings?.imageUrl && avatarInitials; else placeholder"
      class="avatar__initials"
      [style.font-size.px]="
        (settings?.size ? settings?.size : DEFAULT_SIZE) / 3
      "
    >
      {{ avatarInitials }}
    </span>

    <ng-template #placeholder>
      {{ DEFAULT_INITIALS }}
    </ng-template>
  </div>

  <span *ngIf="settings?.isShowLabelNameRight">
    {{ displayName }}
  </span>
</div>
